import React from 'react';
import PropTypes from 'prop-types';
import './ImportantInfoTickbox.scss';

const ImportantInfoTickbox = (props) => {
  const { id, name, label1, label2, input, checked, handleChange } = props;

  return (
    <div className="importantinfo-tickbox form-checkbox-container">
      <span className="relative">
        <input
          id={id}
          className="form-checkbox-input"
          type="checkbox"
          name={name}
          {...input}
          checked={checked}
          onChange={() => handleChange(!checked)}
        />
        <label
          className={`form-checkbox-label autotest-${id}`}
          htmlFor={id}
        ><strong>{label1}</strong><br />{label2}</label>
      </span>
      <div className="form-validation-message">&nbsp;</div>
    </div>
  );
};

ImportantInfoTickbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label1: PropTypes.string,
  label2: PropTypes.string,
  input: PropTypes.object,
  checked: PropTypes.bool,
  handleChange: PropTypes.func
};

ImportantInfoTickbox.defaultProps = {
  handleChange: () => {}
};

export default ImportantInfoTickbox;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/BringYourOwnModem/ImportantInfoTickbox.js
 **/